import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "default-content" }
const _hoisted_3 = { class: "collapse-content" }
const _hoisted_4 = { class: "collapse-content" }
const _hoisted_5 = { class: "collapse-content" }
const _hoisted_6 = { class: "collapse-content" }
const _hoisted_7 = { class: "new-form" }
const _hoisted_8 = { class: "distribution" }
const _hoisted_9 = { class: "list" }
const _hoisted_10 = { class: "total" }
const _hoisted_11 = { class: "total-count" }
const _hoisted_12 = { class: "button" }
const _hoisted_13 = { class: "distribution" }
const _hoisted_14 = { class: "total-row" }
const _hoisted_15 = { class: "preview-count" }
const _hoisted_16 = { class: "overview" }
const _hoisted_17 = { class: "category-button" }
const _hoisted_18 = { class: "list" }

export function render(_ctx, _cache) {
  const _component_Header = _resolveComponent("Header")
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _component_Compass = _resolveComponent("Compass")
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_input = _resolveComponent("el-input")
  const _component_WarningFilled = _resolveComponent("WarningFilled")
  const _component_Check = _resolveComponent("Check")
  const _component_el_button = _resolveComponent("el-button")
  const _component_TopRight = _resolveComponent("TopRight")
  const _component_Memo = _resolveComponent("Memo")
  const _component_Delete = _resolveComponent("Delete")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")
  const _component_CirclePlusFilled = _resolveComponent("CirclePlusFilled")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_collapse = _resolveComponent("el-collapse")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_slider = _resolveComponent("el-slider")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_radio_button = _resolveComponent("el-radio-button")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["windowWidth", "windowHeight"]),
    _createVNode(_component_Navigation, {
      activeMenu: _ctx.NavigationIndex.TARGETGROUP,
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["activeMenu", "windowWidth", "windowHeight"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createElementVNode("div", { class: "danger" }, [
                  _createElementVNode("h4", null, "Zugang verweigert."),
                  _createElementVNode("p", null, "Sie besitzen nicht die erforderliche Berechtigung für diesen Bereich.")
                ], -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, !_ctx.hasPermission['TARG_SELECT'] && !_ctx.loading]
        ]),
        _withDirectives(_createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, { class: "rounded-content" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_collapse, {
                  modelValue: _ctx.activeName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.activeName) = $event)),
                  accordion: "",
                  ref: "coll"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_collapse_item, { name: "1" }, {
                      title: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_el_icon, { size: 32 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Compass)
                            ]),
                            _: 1
                          })
                        ]),
                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "title-label" }, "Zielgruppen", -1))
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _withDirectives((_openBlock(), _createBlock(_component_el_table, { data: _ctx.targetGroupModelList }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_table_column, {
                                prop: "targetgroupid",
                                label: "ID",
                                width: "80"
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "name",
                                label: "Bezeichnung"
                              }, {
                                default: _withCtx((scope) => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.targetGroupModelList[scope.$index].name,
                                    "onUpdate:modelValue": $event => ((_ctx.targetGroupModelList[scope.$index].name) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "description",
                                label: "Beschreibung"
                              }, {
                                default: _withCtx((scope) => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.targetGroupModelList[scope.$index].description,
                                    "onUpdate:modelValue": $event => ((_ctx.targetGroupModelList[scope.$index].description) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "questioncount",
                                label: "Prüfungsfragen"
                              }, {
                                default: _withCtx((scope) => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.targetGroupModelList[scope.$index].questioncount,
                                    "onUpdate:modelValue": $event => ((_ctx.targetGroupModelList[scope.$index].questioncount) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "dateupdate",
                                label: "Letzte Änderung",
                                width: "200"
                              }, {
                                default: _withCtx((scope) => [
                                  _createTextVNode(_toDisplayString(new Intl.DateTimeFormat('de-DE', {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'}).format(new Date(0).setUTCSeconds(_ctx.targetGroupModelList[scope.$index].dateupdate))), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                fixed: "right",
                                label: "",
                                width: "60",
                                class: "warning"
                              }, {
                                default: _withCtx((scope) => [
                                  (_ctx.listSum[_ctx.targetGroupModelList[scope.$index].targetgroupid] < 100)
                                    ? (_openBlock(), _createBlock(_component_el_icon, {
                                        key: 0,
                                        size: 28,
                                        class: "warn",
                                        title: "Verteilung offen"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_WarningFilled)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }),
                              (_ctx.hasPermission['TARG_UPDATE'])
                                ? (_openBlock(), _createBlock(_component_el_table_column, {
                                    key: 0,
                                    fixed: "right",
                                    label: "",
                                    width: "60"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createVNode(_component_el_button, {
                                        type: "success",
                                        onClick: $event => (_ctx.onTargetGroupSaveClick(_ctx.targetGroupModelList[scope.$index])),
                                        circle: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, { size: 16 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Check)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.hasPermission['TARG_UPDATE'])
                                ? (_openBlock(), _createBlock(_component_el_table_column, {
                                    key: 1,
                                    fixed: "right",
                                    label: "",
                                    width: "60"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createVNode(_component_el_button, {
                                        type: "primary",
                                        onClick: $event => (_ctx.onDifficultyClick(_ctx.targetGroupModelList[scope.$index])),
                                        circle: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, { size: 16 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_TopRight)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.hasPermission['TARG_UPDATE'])
                                ? (_openBlock(), _createBlock(_component_el_table_column, {
                                    key: 2,
                                    fixed: "right",
                                    label: "",
                                    width: "60"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createVNode(_component_el_button, {
                                        type: "primary",
                                        onClick: $event => (_ctx.onCategoryClick(_ctx.targetGroupModelList[scope.$index])),
                                        circle: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, { size: 16 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Memo)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.hasPermission['TARG_DELETE'])
                                ? (_openBlock(), _createBlock(_component_el_table_column, {
                                    key: 3,
                                    fixed: "right",
                                    label: "",
                                    width: "60"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createVNode(_component_el_button, {
                                        type: "danger",
                                        onClick: $event => (_ctx.onTargetGroupDeleteClick(_ctx.targetGroupModelList[scope.$index])),
                                        circle: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, { size: 16 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Delete)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["data"])), [
                            [_directive_loading, _ctx.loading]
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    (_ctx.hasPermission['TARG_INSERT'])
                      ? (_openBlock(), _createBlock(_component_el_collapse_item, {
                          key: 0,
                          name: "2"
                        }, {
                          title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_component_el_icon, { size: 32 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_CirclePlusFilled)
                                ]),
                                _: 1
                              })
                            ]),
                            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "title-label" }, "Neue Zielgruppe", -1))
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("div", _hoisted_7, [
                                _createVNode(_component_el_form, {
                                  ref: "newTargetGroupForm",
                                  rules: _ctx.rules,
                                  "label-position": "top",
                                  model: _ctx.newTargetGroupModel,
                                  "label-width": "120px"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_form_item, {
                                      label: "Bezeichnung",
                                      prop: "name"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.newTargetGroupModel.name,
                                          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.newTargetGroupModel.name) = $event)),
                                          onInput: _ctx.onInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Beschreibung",
                                      prop: "description"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.newTargetGroupModel.description,
                                          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.newTargetGroupModel.description) = $event)),
                                          onInput: _ctx.onInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Anzahl der Prüfungsfragen",
                                      prop: "questioncount"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          type: "number",
                                          min: "1",
                                          max: "999",
                                          modelValue: _ctx.newTargetGroupModel.questioncount,
                                          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.newTargetGroupModel.questioncount) = $event)),
                                          onInput: _ctx.onInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_button, {
                                          type: "primary",
                                          disabled: !_ctx.formValid,
                                          onClick: _ctx.onNewTargetGroupClick
                                        }, {
                                          default: _withCtx(() => _cache[10] || (_cache[10] = [
                                            _createTextVNode("Hinzufügen ")
                                          ])),
                                          _: 1
                                        }, 8, ["disabled", "onClick"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["rules", "model"])
                              ])
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.hasPermission['TARG_SELECT']]
        ]),
        _createVNode(_component_el_dialog, {
          title: `Prozentuale Verteilung der Schwierigkeitsgrade für ${_ctx.targetGroupName}` ,
          modelValue: _ctx.showDifficulty,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.showDifficulty) = $event)),
          width: "80%",
          top: "100px"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 16 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, {
                              class: "description",
                              span: 12
                            }, {
                              default: _withCtx(() => _cache[11] || (_cache[11] = [
                                _createTextVNode(" Schwierigkeit ")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_el_col, {
                              class: "description-right",
                              span: 12
                            }, {
                              default: _withCtx(() => _cache[12] || (_cache[12] = [
                                _createTextVNode(" Verteilung in Prozent ")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _cache[13] || (_cache[13] = _createElementVNode("hr", null, null, -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.difficulties, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_row, {
                            class: "difficulty",
                            gutter: 10
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                span: 6,
                                class: "difficulty-name"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 18 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_slider, {
                                    modelValue: _ctx.selectedDifficulties[index],
                                    "onUpdate:modelValue": $event => ((_ctx.selectedDifficulties[index]) = $event),
                                    "show-input": "",
                                    size: "large"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 256))
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 8 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { class: "description-overview" }, {
                              default: _withCtx(() => _cache[14] || (_cache[14] = [
                                _createTextVNode(" Verfügbarkeit der Optionen ")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _cache[17] || (_cache[17] = _createElementVNode("hr", null, null, -1)),
                        (_ctx.optionCounts && _ctx.optionCounts.length > 0)
                          ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, {
                                  span: 12,
                                  class: "counts"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_col, {
                                          span: 24,
                                          class: "count"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", {
                                              style: _normalizeStyle('color: ' + (_ctx.selectedCounts[0] > _ctx.optionCounts[0].option_count ? '#ff0000' : '#000000'))
                                            }, _toDisplayString(_ctx.getPercentageValue(0)), 5),
                                            _createTextVNode(" / " + _toDisplayString(_ctx.optionCounts[0].option_count), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_col, {
                                          span: 24,
                                          class: "count"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", {
                                              style: _normalizeStyle('color: ' + (_ctx.selectedCounts[1] > _ctx.optionCounts[1].option_count ? '#ff0000' : '#000000'))
                                            }, _toDisplayString(_ctx.getPercentageValue(1)), 5),
                                            _createTextVNode(" / " + _toDisplayString(_ctx.optionCounts[1].option_count), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_col, {
                                          span: 24,
                                          class: "count"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", {
                                              style: _normalizeStyle('color: ' + (_ctx.selectedCounts[2] > _ctx.optionCounts[2].option_count ? '#ff0000' : '#000000'))
                                            }, _toDisplayString(_ctx.getPercentageValue(2)), 5),
                                            _createTextVNode(" / " + _toDisplayString(_ctx.optionCounts[2].option_count), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_col, {
                                          span: 24,
                                          class: "count"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", {
                                              style: _normalizeStyle('color: ' + (_ctx.selectedCounts[3] > _ctx.optionCounts[3].option_count ? '#ff0000' : '#000000'))
                                            }, _toDisplayString(_ctx.getPercentageValue(3)), 5),
                                            _createTextVNode(" / " + _toDisplayString(_ctx.optionCounts[3].option_count), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_col, {
                                          span: 24,
                                          class: "count"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", {
                                              style: _normalizeStyle('color: ' + (_ctx.selectedCounts[4] > _ctx.optionCounts[4].option_count ? '#ff0000' : '#000000'))
                                            }, _toDisplayString(_ctx.getPercentageValue(4)), 5),
                                            _createTextVNode(" / " + _toDisplayString(_ctx.optionCounts[4].option_count), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_col, { span: 12 }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_11, [
                                      _createVNode(_component_el_row, { class: "count-row" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_col, {
                                            span: 18,
                                            class: "count-label"
                                          }, {
                                            default: _withCtx(() => _cache[15] || (_cache[15] = [
                                              _createTextVNode(" Optionen gesamt: ")
                                            ])),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_col, {
                                            span: 6,
                                            align: "right",
                                            class: "count-value"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.totalOptionCount), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_row, { class: "count-row" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_col, {
                                            span: 18,
                                            class: "count-label"
                                          }, {
                                            default: _withCtx(() => _cache[16] || (_cache[16] = [
                                              _createTextVNode(" Fragen gesamt: ")
                                            ])),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_col, {
                                            span: 6,
                                            align: "right",
                                            class: "count-value"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.totalQuestionCount), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", {
                                      class: "sum",
                                      style: _normalizeStyle('color: ' + (_ctx.difficultySum <= 100 ? (_ctx.difficultySum == 100 ? '#5A8F39' : '#EA7511') : '#BC380E'))
                                    }, _toDisplayString(_ctx.getDifficultySum()) + "% ", 5),
                                    _createElementVNode("div", _hoisted_12, [
                                      _createVNode(_component_el_button, {
                                        disabled: !_ctx.validatePercantage(),
                                        type: _ctx.validatePercantage() ? 'success' : 'info',
                                        size: "large",
                                        onClick: _ctx.onDifficultySave,
                                        circle: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, { size: 32 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Check)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["disabled", "type", "onClick"])
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["title", "modelValue"]),
        _createVNode(_component_el_dialog, {
          title: `Prozentuale Verteilung der Fragen auf die Kategorien in der Zielgruppe ${_ctx.targetGroupName}` ,
          modelValue: _ctx.showCategories,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.showCategories) = $event)),
          width: "70%",
          top: "20px"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_el_row, { gutter: 10 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 4 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_15, [
                          _cache[18] || (_cache[18] = _createElementVNode("label", { class: "preview-count" }, "Vorschau", -1)),
                          _createVNode(_component_el_radio_group, {
                            modelValue: _ctx.previewTargetCount,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.previewTargetCount) = $event)),
                            onChange: _ctx.onPreviewCountChange
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_radio_button, {
                                value: 10,
                                label: 10,
                                size: "small"
                              }),
                              _createVNode(_component_el_radio_button, {
                                value: 28,
                                label: 28,
                                size: "small"
                              }),
                              _createVNode(_component_el_radio_button, {
                                value: 60,
                                label: 60,
                                size: "small"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onChange"])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.totalTargetCount) + " / " + _toDisplayString(_ctx.previewTargetCount) + " Fragen", 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 10 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "category-sum",
                          style: _normalizeStyle('color: ' + (_ctx.categorySum <= 100 ? (_ctx.categorySum == 100 ? '#5A8F39' : '#EA7511') : '#BC380E'))
                        }, _toDisplayString(_ctx.categorySum) + "% ", 5)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 2 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_el_button, {
                            disabled: !_ctx.validateCategoryPercantage(),
                            type: _ctx.validateCategoryPercantage() ? 'success' : 'info',
                            size: "large",
                            onClick: _ctx.onCategoryDistributionSave,
                            circle: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, { size: 32 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Check)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["disabled", "type", "onClick"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              (_ctx.categoryTargetGroupList)
                ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        span: 24,
                        align: "right"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_el_row, { class: "difficulty" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, {
                                  class: "description",
                                  span: 6
                                }, {
                                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                                    _createTextVNode(" Kategorie ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_el_col, {
                                  class: "description",
                                  span: 9
                                }, {
                                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                                    _createTextVNode(" Verteilung in Prozent ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_el_col, {
                                  class: "description",
                                  span: 9
                                }, {
                                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                                    _createTextVNode(" Verfügbarkeit ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _cache[22] || (_cache[22] = _createElementVNode("hr", null, null, -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryTargetGroupList, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_row, {
                                class: "difficulty",
                                gutter: 10
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, {
                                    span: 7,
                                    class: "category-name"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.getCategoryName(item.categoryid)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_el_col, { span: 14 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_slider, {
                                        modelValue: item.percentage,
                                        "onUpdate:modelValue": $event => ((item.percentage) = $event),
                                        "show-input": "",
                                        onInput: _ctx.getCategorySum
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_el_col, {
                                    span: 2,
                                    class: "count-question",
                                    align: "right"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", {
                                        style: _normalizeStyle('color: ' + (Math.round(_ctx.previewTargetCount / 100 * item.percentage) <= item.question_count ? '#5A8F39' : '#BC380E'))
                                      }, _toDisplayString(Math.round(_ctx.previewTargetCount / 100 * item.percentage)), 5),
                                      _createTextVNode(" / " + _toDisplayString(item.question_count), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            }), 256))
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])), [
              [_directive_loading, _ctx.processPercenatges]
            ])
          ]),
          _: 1
        }, 8, ["title", "modelValue"])
      ])
    ])
  ], 64))
}